import { Pipe, PipeTransform } from '@angular/core';
import { Addon } from '@app/shared/interfaces';

@Pipe({
  standalone: false,
  name: 'findDirectAddon',
})
export class FindDirectAddonPipe implements PipeTransform {
  transform(addons: Addon[]): Addon | null {
    return addons.find((addon) => addon.description.toLowerCase().includes('direct'));
  }
}
